import {
  Icon,
  IconSizeClasses,
  type IconProps,
  Tooltip,
} from '@eppendorf/vnls-react-components';

interface DashboardCardTitleProps {
  icon: IconProps['name'];
  title: string;
  hint: string;
  subheadline?: string;
  tone?: 'gray' | 'red' | 'orange';
}

export function DashboardCardTitle({
  icon,
  title,
  hint,
  subheadline,
  tone,
}: DashboardCardTitleProps) {
  return (
    <h3
      className={
        tone
          ? `dashboard-widget__title dashboard-widget__title--${tone}`
          : 'dashboard-widget__title'
      }
    >
      <Icon name={icon} size={IconSizeClasses.XSmall} alt="" />
      <span className="dashboard-widget__title-content">
        <Tooltip
          side="top"
          trigger={
            <button type="button" className="dashboard-widget__title-trigger">
              {title}
            </button>
          }
        >
          <div className="dashboard-tooltip">{hint}</div>
        </Tooltip>
        {subheadline && (
          <span className="dashboard-widget__title-subheadline">{subheadline}</span>
        )}
      </span>
    </h3>
  );
}
